<template>
  <div class="bind_result" :class="$route.query.state==1?'success':'error'">
    <p class="title">
      <span>{{$route.query.state==1?'绑定成功':'绑定失败'}}</span>
    </p>
    <p class="test">
      <i class="icon" :class="$route.query.state==1?'el-icon-circle-check':'el-icon-circle-close'"></i>
      <span>{{$route.query.state==1?'您已成功绑定该账户':$route.query.msg || '绑定失败，请重试'}}</span>
    </p>
    <el-button class="btn" type="primary" @click="IKnow">我知道了</el-button>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  metaInfo: { title: "账户绑定 - 多比商城" },
  name: "bindResult",
  data() {
    return {};
  },
  mounted() {
    // 点击绑定按钮进入的提示页面，后台传参state,msg
    // console.log(this.$route.query);
    let contentWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    let fontSize = (contentWidth * 18) / 375;
    document.documentElement.style.fontSize = fontSize + "px";
    // alert(contentWidth);
  },
  methods: {
    IKnow() {
      // WeixinJSBridge.call('closeWindow');
      wx.closeWindow();
    },
  },
};
</script>

<style lang="less" scoped>
.bind_result {
  height: 100%;
  box-sizing: border-box;
  font-size: 0.875rem;
  text-align: center;
  padding-top: 30%;
  .title {
    margin-bottom: 2rem;
    padding: 0 2rem;
    word-wrap: break-word;
    font-size: 1.5rem;
  }
  .test {
    margin-bottom: 6rem;
    padding: 0 2rem;
    word-wrap: break-word;
    .icon {
      vertical-align: middle;
      font-size: 1.5rem;
      margin-right: 0.625rem;
    }
  }
  .btn {
    width: 12.25rem;
    letter-spacing: 0.1792rem;
    padding: 0.5rem 1.25rem;
    font-size: 0.875rem;
  }
}
.success {
  color: #67c23a;
}
.error {
  color: #f56c6c;
}
</style>